// Here are utils functions used through the app

export const handleSubMenuSelection = (key, dispatch) => {
      
    if (key === "products") {
        dispatch({
            type: "SET",
            key: "settingsMenu",
            payload: {"products" : "active", "calculTeg": "", "productsCategories" : "", "institutions" : "", "institutionsCategories" : "", "users" : "", "roles" : "", "zones" : "", "alertes": "", "configuration": "", "logs" : "", "webgate": "", "treatment" : ""},
        });
    }
    if (key === "calculTeg") {
        dispatch({
            type: "SET",
            key: "settingsMenu",
            payload: {"products" : "", "calculTeg": "active", "productsCategories" : "", "institutions" : "", "institutionsCategories" : "", "users" : "", "roles" : "", "zones" : "", "alertes": "", "configuration": "", "logs" : "", "webgate": "", "treatment" : ""},
        });
    }
    if (key === "products-categories") {
        dispatch({
            type: "SET",
            key: "settingsMenu",
            payload: {"products" : "", "calculTeg": "", "productsCategories" : "active", "institutions" : "", "institutionsCategories" : "", "users" : "", "roles" : "", "zones" : "", "alertes": "", "configuration": "", "logs" : "", "webgate": "", "treatment" : ""},
        });
    }
    if (key === "institutions") {
        dispatch({
            type: "SET",
            key: "settingsMenu",
            payload: {"products" : "", "calculTeg": "", "productsCategories" : "", "institutions" : "active", "institutionsCategories" : "", "users" : "", "roles" : "", "zones" : "", "alertes": "", "configuration": "", "logs" : "", "webgate": "", "treatment" : ""},
        });
    }
    if (key === "institutions-categories") {
        dispatch({
            type: "SET",
            key: "settingsMenu",
            payload: {"products" : "", "calculTeg": "", "productsCategories" : "", "institutions" : "", "institutionsCategories" : "active", "users" : "", "roles" : "", "zones" : "", "alertes": "", "configuration": "", "logs" : "", "webgate": "", "treatment" : ""},
        });
    }
    if (key === "users") {
        dispatch({
            type: "SET",
            key: "settingsMenu",
            payload: {"products" : "", "calculTeg": "", "productsCategories" : "", "institutions" : "", "institutionsCategories" : "", "users" : "active", "roles" : "", "alertes": "", "configuration": "", "logs" : "", "webgate": "", "treatment" : ""},
        });
    }

        if (key === "roles") {
            dispatch({
                type: "SET",
                key: "settingsMenu",
                payload: {"products" : "", "calculTeg": "", "productsCategories" : "", "institutions" : "", "institutionsCategories" : "", "users" : "", "roles" : "active", "zones" : "", "alertes": "", "configuration": "", "logs" : "", "webgate": "", "treatment" : ""},
            });

    }

    if (key === "zones") {
        dispatch({
            type: "SET",
            key: "settingsMenu",
            payload: {"products" : "", "calculTeg": "", "productsCategories" : "", "institutions" : "", "institutionsCategories" : "", "users" : "", "roles" : "", "zones" : "active", "alertes": "", "configuration": "", "logs" : "", "webgate": "", "treatment" : ""},
        });

}
    if (key === "alertes") {
        dispatch({
            type: "SET",
            key: "settingsMenu",
            payload: {"products" : "", "calculTeg": "", "productsCategories" : "", "institutions" : "", "institutionsCategories" : "", "users" : "", "roles" : "", "zones" : "", "alertes": "active", "configuration": "", "logs" : "", "webgate": "", "treatment" : ""},
        });

}
if (key === "configuration") {
    dispatch({
        type: "SET",
        key: "settingsMenu",
        payload: {"products" : "", "calculTeg": "", "productsCategories" : "", "institutions" : "", "institutionsCategories" : "", "users" : "", "roles" : "", "zones" : "", "alertes": "", "logs": "", "configuration": "active", "webgate": "", "treatment" : ""},
    });

}
    if (key === "logs") {
        dispatch({
            type: "SET",
            key: "settingsMenu",
            payload: {"products" : "", "calculTeg": "", "productsCategories" : "", "institutions" : "", "institutionsCategories" : "", "users" : "", "roles" : "", "zones" : "", "alertes": "", "configuration": "", "logs" : "active", "webgate": "", "treatment" : ""},
        });
    }

    if (key === "webgate") {
        dispatch({
            type: "SET",
            key: "settingsMenu",
            payload: {"products" : "", "calculTeg": "", "productsCategories" : "", "institutions" : "", "institutionsCategories" : "", "users" : "", "roles" : "", "zones" : "", "alertes": "", "configuration": "",  "logs" : "", "webgate": "active", "treatment" : ""},
        });
    }

    if (key === "treatment") {
        dispatch({
            type: "SET",
            key: "settingsMenu",
            payload: {"products" : "", "calculTeg": "", "productsCategories" : "", "institutions" : "", "institutionsCategories" : "", "users" : "", "roles" : "", "logs" : "", "treatment" : "active"},
        });
    }

    if (key === "suivi-taux") {
        dispatch({
            type: "SET",
            key: "suiviMenu",
            payload: {"suiviTaux" : "active", "suiviTransmission" : ""},
        });
    }

    if (key === "suivi-transmission") {
        dispatch({
            type: "SET",
            key: "suiviMenu",
            payload: {"suiviTaux" : "", "suiviTransmission" : "active"},
        });
    }
}

export    const handleMenuSelection = (key, dispatch, states) => {
    if (key === "dashboard") {
        dispatch({
            type: "SET",
            key: "menu",
            payload: {"dashboard" : true, "transmission" : false, "monitoring" : false, "reports" : false, "settings" : false},
        });
        
    }

    if (key === "transmission") {
        dispatch({
            type: "SET",
            key: "menu",
            payload: {"dashboard" : false, "transmission" : true, "monitoring" : false, "reports" : false, "settings" : false},
        });
    }

    // if (key === "monitoring") {
    //     dispatch({
    //         type: "SET",
    //         key: "menu",
    //         payload: {"dashboard" : false, "transmission" : false, "monitoring" : true, "reports" : false, "settings" : false},
    //     });
    // }

    if (key === "reports") {
        dispatch({
            type: "SET",
            key: "menu",
            payload: {"dashboard" : false, "transmission" : false, "monitoring" : false, "reports" : true, "settings" : false},
        });
    }

    if (key === "notifications") {
        dispatch({
            type: "SET",
            key: "menu",
            payload: {"dashboard" : false, "transmission" : false, "monitoring" : false, "reports" : false, "settings" : false},
        });
    }

    if (key === "user") {
        dispatch({
            type: "SET",
            key: "menu",
            payload: {"dashboard" : false, "transmission" : false, "monitoring" : false, "reports" : false, "settings" : false},
        });
    }

    if (key === "settings") {
        dispatch({
            type: "SET",
            key: "menu",
            payload: {"dashboard" : false, "transmission" : false, "monitoring" : false, "reports" : false, "settings" : true},
        });
        if(states.menuSettingsShow === false) {

            dispatch({
                type: "SET",
                key: "menuSettingsShow",
                payload: true,
            });
        } else {
            dispatch({
                type: "SET",
                key: "menuSettingsShow",
                payload: false,
            });
        }
        
    } else {
        dispatch({
            type: "SET",
            key: "settingsMenu",
            payload: {"products" : "", "calculTeg": "", "productsCategories" : "", "institutions" : "", "institutionsCategories" : "", "users" : "", "roles" : "", "zones" : "", "alertes": "",  "logs" : "", "configuration": "", "webgate": "", "treatment" : ""},
        });
    }




    // --------------------------

    if (key === "monitoring") {
        dispatch({
            type: "SET",
            key: "menu",
            payload: {"dashboard" : false, "transmission" : false, "monitoring" : true, "reports" : false, "settings" : false},
        });
        if(states.menuMonitoringShow === false) {

            dispatch({
                type: "SET",
                key: "menuMonitoringShow",
                payload: true,
            });
        } else {
            dispatch({
                type: "SET",
                key: "menuSettingsShow",
                payload: false,
            });
        }
        // menuMonitoringShow
    } else {
        dispatch({
            type: "SET",
            key: "suiviMenu",
            payload: {"suiviTaux" : "", "suiviTransmission" : ""},
        });
    }

    // --------------------------
}

export const searchFunction = (rows, search) => {
    const columns = rows[0] && Object.keys(rows[0])
    return rows.filter((row) =>
      columns.some(
        (column) => row[column]?.toString().toLowerCase().indexOf(search?.toString().toLowerCase()) > -1));
  }

  export const sortFunction = (items) => { 
      return items.sort(function (a, b) {
        return a.value - b.value;
      })
  }

  export const reload = (time) => {
      if(!time){time = 1500}
    setTimeout(() => {
      window.location.reload()
    }, time);
  };


  export const reformartErrorMsg = msg => {
   return msg.replace(".", " ")
};

 
export const customFormatDate = (date) => {
    const temp = new Date(date);
    var gotMonth = temp.getMonth()+1;
    var correct_month;
    var gotDay = temp.getDate();
    var correct_day;
    if(gotMonth < 10) {
        correct_month = "0" + gotMonth;
    } else { 
        correct_month = gotMonth;
    }
    if(gotDay < 10) {
        correct_day = "0" + gotDay;
    } else { 
        correct_day = gotDay;
    }
   const formattedDate = (correct_day)+"/"+(correct_month)+"/"+temp.getFullYear();
   return formattedDate;
}

export const customFormatHour = (date) => {
    const temp = new Date(date);
    var gotMinutes = temp.getMinutes();
    var correct_minute;
    var gotHours = temp.getHours();
    var correct_hour;
    var gotSeconds = temp.getSeconds();
    var correct_second;
    if(gotHours < 10) {
        correct_hour = "0" + gotHours;
    } else { 
        correct_hour = gotHours;
    }
    if(gotMinutes < 10) {
        correct_minute = "0" + gotMinutes;
    } else { 
        correct_minute = gotMinutes;
    }
    if(gotSeconds < 10) {
        correct_second = "0" + gotSeconds;
    } else { 
        correct_second = gotSeconds;
    }

    const formattedHour = (correct_hour)+":"+(correct_minute)
    // +":"+(correct_second);
    return formattedHour;
}


  export const groupBy = (list, keyGetter) => {
    const map = new Map();
    list?.forEach((item) => {
         const key = keyGetter(item);
         const collection = map.get(key);
         if (!collection) {
             map.set(key, [item]);
         } else {
             collection.push(item);
         }
    });
    return map;
}